export interface ArticleData {
  slug: string;
  tag: string;
  tagColor: string;
  image: string;
  title: { en: string; pt: string; de: string };
  excerpt: { en: string; pt: string; de: string };
  date: string;
  readTime: string;
}

export const articles: ArticleData[] = [
  {
    slug: "cssbuy-spreadsheet-guide",
    tag: "Guide",
    tagColor: "text-primary-600 bg-primary-50",
    image: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20laptop%20screen%20displaying%20organized%20spreadsheet%20data%20on%20clean%20white%20marble%20desk%20soft%20natural%20lighting%20editorial%20photography%20warm%20beige%20tones&width=800&height=450&seq=article-01&orientation=landscape",
    title: {
      en: "CSSBuy Spreadsheet 2026: Complete Guide to Products, QC & Links",
      pt: "CSSBuy Spreadsheet 2026: Guia Completo de Produtos, QC e Links",
      de: "CSSBuy Spreadsheet 2026: Kompletter Leitfaden zu Produkten, QC & Links",
    },
    excerpt: {
      en: "A complete guide explaining what a CSSBuy Spreadsheet is, how it works, and how to compare products, check QC photos, and estimate shipping costs.",
      pt: "Um guia completo explicando o que é um CSSBuy Spreadsheet, como funciona e como comparar produtos, ver fotos de QC e estimar custos de envio.",
      de: "Ein vollständiger Leitfaden, der erklärt, was ein CSSBuy Spreadsheet ist, wie es funktioniert und wie man Produkte vergleicht, QC-Fotos prüft und Versandkosten schätzt.",
    },
    date: "2026-08-26",
    readTime: "8 min",
  },
  {
    slug: "cssbuy-review-2026",
    tag: "Review",
    tagColor: "text-accent-600 bg-accent-50",
    image: "https://readdy.ai/api/search-image?query=Close-up%20of%20hand%20holding%20smartphone%20browsing%20online%20store%20with%20package%20boxes%20in%20background%20soft%20natural%20lighting%20editorial%20photography%20warm%20neutral%20tones&width=800&height=450&seq=article-02&orientation=landscape",
    title: {
      en: "CSSBuy Review 2026: Features, Pros, Cons & Buyer Guide",
      pt: "CSSBuy Review 2026: Recursos, Prós, Contras e Guia do Comprador",
      de: "CSSBuy Review 2026: Funktionen, Vor- und Nachteile & Käuferleitfaden",
    },
    excerpt: {
      en: "An honest review covering CSSBuy features, workflow, pros and cons to help buyers understand what to expect before using the platform.",
      pt: "Uma avaliação honesta cobrindo recursos, fluxo de trabalho, prós e contras do CSSBuy para ajudar compradores a entender o que esperar.",
      de: "Eine ehrliche Bewertung der CSSBuy-Funktionen, des Workflows, der Vor- und Nachteile, um Käufern zu helfen, zu verstehen, was sie erwartet.",
    },
    date: "2026-08-20",
    readTime: "6 min",
  },
  {
    slug: "cssbuy-shipping-cost",
    tag: "Shipping",
    tagColor: "text-secondary-600 bg-secondary-50",
    image: "https://readdy.ai/api/search-image?query=Stacked%20cardboard%20shipping%20boxes%20with%20international%20shipping%20labels%20on%20wooden%20table%20soft%20natural%20lighting%20editorial%20photography%20warm%20beige%20tones&width=800&height=450&seq=article-03&orientation=landscape",
    title: {
      en: "CSSBuy Shipping Cost: Complete Guide to Rates, Weight & Methods",
      pt: "Custo de Envio CSSBuy: Guia Completo de Taxas, Peso e Métodos",
      de: "CSSBuy Versandkosten: Kompletter Leitfaden zu Tarifen, Gewicht & Methoden",
    },
    excerpt: {
      en: "Understand how shipping costs are calculated based on weight, volume, destination, carrier and method. Learn to estimate your total shipping expenses.",
      pt: "Entenda como os custos de envio são calculados com base em peso, volume, destino, transportadora e método. Aprenda a estimar seus custos totais.",
      de: "Verstehen Sie, wie Versandkosten basierend auf Gewicht, Volumen, Zielort, Spedition und Methode berechnet werden. Lernen Sie, Ihre Versandkosten zu schätzen.",
    },
    date: "2026-08-18",
    readTime: "7 min",
  },
  {
    slug: "cssbuy-qc-guide",
    tag: "QC",
    tagColor: "text-accent-700 bg-accent-50",
    image: "https://readdy.ai/api/search-image?query=Close-up%20of%20quality%20inspection%20photos%20on%20tablet%20screen%20showing%20product%20details%20soft%20studio%20lighting%20editorial%20photography%20clean%20minimal%20setup&width=800&height=450&seq=article-04&orientation=landscape",
    title: {
      en: "CSSBuy QC Guide: How to Read and Check Quality Control Photos",
      pt: "Guia de QC CSSBuy: Como Ler e Verificar Fotos de Controle de Qualidade",
      de: "CSSBuy QC-Leitfaden: So lesen und prüfen Sie Qualitätskontrollfotos",
    },
    excerpt: {
      en: "Learn what QC photos are, what details to look for, common mistakes to avoid, and how to use QC information to make better buying decisions.",
      pt: "Aprenda o que são fotos de QC, quais detalhes observar, erros comuns a evitar e como usar informações de QC para tomar melhores decisões.",
      de: "Lernen Sie, was QC-Fotos sind, auf welche Details Sie achten müssen, welche Fehler Sie vermeiden sollten und wie Sie QC-Informationen nutzen.",
    },
    date: "2026-08-15",
    readTime: "5 min",
  },
  {
    slug: "cssbuy-coupon-guide",
    tag: "Deals",
    tagColor: "text-primary-600 bg-primary-50",
    image: "https://readdy.ai/api/search-image?query=Shopping%20coupon%20tags%20and%20discount%20vouchers%20scattered%20on%20clean%20white%20surface%20soft%20natural%20lighting%20editorial%20product%20photography%20warm%20tones&width=800&height=450&seq=article-05&orientation=landscape",
    title: {
      en: "CSSBuy Coupon Guide: How to Find Current Offers & Discounts",
      pt: "Guia de Cupons CSSBuy: Como Encontrar Ofertas e Descontos Atuais",
      de: "CSSBuy Coupon-Leitfaden: So finden Sie aktuelle Angebote & Rabatte",
    },
    excerpt: {
      en: "Discover where to find current CSSBuy coupons, how to apply discount codes, and what to verify before using any promotional offer.",
      pt: "Descubra onde encontrar cupons CSSBuy atuais, como aplicar códigos de desconto e o que verificar antes de usar qualquer oferta promocional.",
      de: "Entdecken Sie, wo Sie aktuelle CSSBuy-Coupons finden, wie Sie Rabattcodes anwenden und was Sie vor der Nutzung eines Angebots überprüfen sollten.",
    },
    date: "2026-08-12",
    readTime: "4 min",
  },
  {
    slug: "best-shoes-cssbuy",
    tag: "Products",
    tagColor: "text-secondary-600 bg-secondary-50",
    image: "https://readdy.ai/api/search-image?query=Collection%20of%20various%20premium%20sneakers%20and%20shoes%20arranged%20artistically%20on%20clean%20background%20soft%20natural%20lighting%20editorial%20photography%20high%20detail&width=800&height=450&seq=article-06&orientation=landscape",
    title: {
      en: "Best Shoes to Research on CSSBuy Spreadsheet in 2026",
      pt: "Melhores Sapatos para Pesquisar no CSSBuy Spreadsheet em 2026",
      de: "Beste Schuhe für CSSBuy Spreadsheet-Recherche 2026",
    },
    excerpt: {
      en: "Explore the most popular shoe categories available on CSSBuy spreadsheets, including sneakers, boots, sandals, and tips for finding your size.",
      pt: "Explore as categorias de sapatos mais populares disponíveis nos spreadsheets CSSBuy, incluindo tênis, botas, sandálias e dicas para encontrar seu tamanho.",
      de: "Erkunden Sie die beliebtesten Schuhkategorien auf CSSBuy Spreadsheets, einschließlich Sneakers, Stiefel, Sandalen und Tipps zur Größenfindung.",
    },
    date: "2026-08-10",
    readTime: "6 min",
  },
  {
    slug: "cssbuy-safety-guide",
    tag: "Safety",
    tagColor: "text-foreground-700 bg-background-100",
    image: "https://readdy.ai/api/search-image?query=Secure%20padlock%20and%20shield%20icons%20with%20shopping%20elements%20on%20clean%20white%20background%20soft%20natural%20lighting%20editorial%20photography%20minimal%20design&width=800&height=450&seq=article-07&orientation=landscape",
    title: {
      en: "CSSBuy Safety Guide: Protect Yourself While Shopping Online",
      pt: "Guia de Segurança CSSBuy: Proteja-se Enquanto Compra Online",
      de: "CSSBuy Sicherheitsleitfaden: Schützen Sie sich beim Online-Shopping",
    },
    excerpt: {
      en: "Essential safety tips for CSSBuy users: verify links, protect passwords, avoid scams, check seller information, and confirm payment details before ordering.",
      pt: "Dicas essenciais de segurança para usuários CSSBuy: verifique links, proteja senhas, evite golpes, confira informações de vendedores e confirme detalhes de pagamento.",
      de: "Wichtige Sicherheitstipps für CSSBuy-Nutzer: Links überprüfen, Passwörter schützen, Betrug vermeiden, Verkäuferinformationen prüfen und Zahlungsdetails bestätigen.",
    },
    date: "2026-08-08",
    readTime: "5 min",
  },
  {
    slug: "cssbuy-vs-agents",
    tag: "Comparison",
    tagColor: "text-accent-600 bg-accent-50",
    image: "https://readdy.ai/api/search-image?query=Two%20laptop%20computers%20side%20by%20side%20showing%20different%20shopping%20websites%20on%20clean%20desk%20soft%20natural%20lighting%20editorial%20photography%20warm%20neutral%20tones&width=800&height=450&seq=article-08&orientation=landscape",
    title: {
      en: "CSSBuy vs Other Shopping Agents: Comparison Guide 2026",
      pt: "CSSBuy vs Outros Agentes de Compras: Guia de Comparação 2026",
      de: "CSSBuy vs andere Shopping-Agenten: Vergleichsleitfaden 2026",
    },
    excerpt: {
      en: "Compare CSSBuy with other shopping agents across key factors: fees, shipping options, QC process, warehouse features, and user experience.",
      pt: "Compare o CSSBuy com outros agentes de compras em fatores-chave: taxas, opções de envio, processo de QC, recursos de armazém e experiência do usuário.",
      de: "Vergleichen Sie CSSBuy mit anderen Shopping-Agenten in Schlüsselfaktoren: Gebühren, Versandoptionen, QC-Prozess, Lagerfunktionen und Benutzererfahrung.",
    },
    date: "2026-08-05",
    readTime: "7 min",
  },
  {
    slug: "cssbuy-warehouse-guide",
    tag: "Warehouse",
    tagColor: "text-primary-600 bg-primary-50",
    image: "https://readdy.ai/api/search-image?query=Organized%20warehouse%20shelves%20with%20packaged%20boxes%20soft%20industrial%20lighting%20editorial%20photography%20clean%20modern%20logistics%20facility%20warm%20tones&width=800&height=450&seq=article-09&orientation=landscape",
    title: {
      en: "CSSBuy Warehouse Guide: Storage, QC & Consolidation Explained",
      pt: "Guia do Armazém CSSBuy: Armazenamento, QC e Consolidação Explicados",
      de: "CSSBuy Warehouse-Leitfaden: Lagerung, QC & Konsolidierung erklärt",
    },
    excerpt: {
      en: "Understand how CSSBuy warehouse works: storage duration, consolidation options, repackaging services, and how to manage your inventory efficiently.",
      pt: "Entenda como funciona o armazém CSSBuy: duração de armazenamento, opções de consolidação, serviços de reembalagem e como gerenciar seu estoque.",
      de: "Verstehen Sie, wie das CSSBuy-Lager funktioniert: Lagerdauer, Konsolidierungsoptionen, Umpack-Services und effizientes Bestandsmanagement.",
    },
    date: "2026-08-03",
    readTime: "6 min",
  },
  {
    slug: "cssbuy-beginner-guide",
    tag: "Beginner",
    tagColor: "text-secondary-600 bg-secondary-50",
    image: "https://readdy.ai/api/search-image?query=Person%20sitting%20at%20clean%20minimal%20desk%20using%20laptop%20for%20online%20shopping%20with%20coffee%20cup%20soft%20natural%20window%20light%20editorial%20lifestyle%20photography%20warm%20tones&width=800&height=450&seq=article-10&orientation=landscape",
    title: {
      en: "CSSBuy Beginner Guide: First Steps for New Buyers in 2026",
      pt: "Guia para Iniciantes CSSBuy: Primeiros Passos para Novos Compradores em 2026",
      de: "CSSBuy Einsteigerleitfaden: Erste Schritte für neue Käufer 2026",
    },
    excerpt: {
      en: "A step-by-step beginner guide covering account setup, finding products, using spreadsheets, placing orders, and understanding the complete buying workflow.",
      pt: "Um guia passo a passo para iniciantes cobrindo configuração de conta, encontrar produtos, usar spreadsheets, fazer pedidos e entender o fluxo completo.",
      de: "Eine Schritt-für-Schritt-Anleitung für Einsteiger: Konto-Setup, Produkte finden, Spreadsheets nutzen, Bestellungen aufgeben und den kompletten Kaufablauf verstehen.",
    },
    date: "2026-08-01",
    readTime: "9 min",
  },
];